export default __webpack_public_path__ + "static/Google_Play_Store-a829bd7058890a6e6d61b5414b10c1a1.png";